import React, { useEffect, useState, useContext }from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col,
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import masterFunction from './master.functions';
import notification from '../../components/notification.component';
import tableMaster from './master.table';
import DataTable from 'react-data-table-component';
import general from '../../general/general.functions';
import moment from 'moment';
import ConfirmAlert from '../../components/confirm.component';
import { ConfigContext } from '../../context/config.context';
import utils from '../../utils/utils.functions';
import DataTableExtensions from 'react-data-table-component-extensions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';


const Master = () => {

  const { config, rol } = useContext(ConfigContext);
  const [modo, setModo] = useState('I');
  const [idMod, setModId] = useState(0);
  const [listado, setListado] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [confirm2, setConfirm2] = useState(false);
  const [remove, setRemove] = useState(null);
  const [close, setClose] = useState(null);
  const [listacomplete, setComplete] = useState([]);
  const { register, handleSubmit, reset, errors } = useForm();

  const history = useHistory();

  const onSubmit = data => {
    if (modo === 'I') {
      masterFunction.register(data).then((response) => {
        if (response.status === 200) {
          listaMaster();
          notification.success();
          resetForm();
        }
      })
    } else {
      masterFunction.update({...data, id: idMod}).then((response) => {
        if (response.status === 200) {
          listaMaster();
          notification.success();
          resetForm();
        }
      })
    }
  }

  const resetForm = () => {
    reset({
      description: '',
      date_aperture: '',
    });
    setModId('I');
    setModId(0);
  }

  const listaTipo = () => {
    general.tiposSalidas().then((tipos) => {
      setTipos(tipos);
    })
  }

  const listaMaster = () => {
    masterFunction.listado().then((response) => {
      setListado(response);
    });
    masterFunction.listadocomplete().then((response) => {
      setComplete(response);
    })
  }

  const selectionClient = (row) => {
    reset({
      ...row,
      date_aperture: moment(row.date_aperture).format('YYYY-MM-DD'),
    });
    setModId(row.id);
    setModo('M');
  }

  const cancelOperation = () => {
    reset({});
    setModo('I');
  }

  useEffect(() => {
    listaTipo();
    listaMaster();
  },[])

  const removeMaster = (row) => {
    setRemove(row.id);
    setConfirm(true);
  }

  const removeAccept = () => {
    masterFunction.removerMaster({ master_id: remove }).then((response) => {
      if (response.data.master_eliminada) {
        notification.success();
        listaMaster();
        setConfirm(false);
      } else {
        if (response.data.hasguide) {
          notification.warning(response.data.message);
        } else {
          notification.warning('La guia master no puede ser removida.');
        }
      }
    });
  }

  const closeMaster = (row) => {
    setClose(row.id);
    setConfirm2(true);
  }

  const closedmaster = () => {
    masterFunction.cierreGuiaMaster({ id: close }).then((response) => {
      if (response.cierre_guia_master) { 
        notification.success();
        setConfirm2(false);
        setClose(null);
        listaMaster();
      } else {
        notification.warning('Intentelo nuevamente ocurrio un problema.');
      }
    })
  }

  return (
  <>
    <Row>
      <Col lg={12}>
        <Card>
        {rol === 1 &&
         <Row>
           <Col className="d-flex justify-content-end">
             <button onClick={() => history.push('/tipos-salidas')} type="button" className="btnx btnx-warn">
              <FontAwesomeIcon icon={faCog} /> {' '}
              Configuración
             </button>
           </Col>
         </Row>
        }
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col lg={6}>
                <div className="grupo-input">
                  <small>Tipo de salida</small>
                  <select className={`form-control input-border ${errors.type_id && "is-invalid"}`} name="type_id" ref={register({ required: true, validate: value => value !== 'null'})}>
                    <option value="null">Seleccionar..</option>
                    {tipos.map((tipos) => {
                      return <option key={tipos.id} value={tipos.id}>{tipos.description}</option>
                    })}
                  </select>
                </div>
                <div className="grupo-input">
                  <small>Descripción</small>
                  <input type="text" className={`form-control input-border ${errors.description && "is-invalid"}`} name="description" ref={register({ required: true })} />
                </div>
                </Col>
                <Col lg={6}>
                <div className="grupo-input">
                  <small>Fecha de salida</small>
                  <input type="date" className={`form-control input-border ${errors.date_aperture && "is-invalid"}`} name="date_aperture" ref={register({ required: true })}/>
                </div>
                <div className="grupo-input">
                  <small>Notificaciones</small>
                  <select className={`form-control input-border ${errors.notification && "is-invalid"}`} name="notification" ref={register({ required: true, validate: value => value !== 'null' })}>
                    <option value="null">Seleccionar..</option>
                    <option value="1">SI</option>
                    <option value="0">NO</option>
                  </select>
                </div>
                <div className="grupo-input mt-2">
                    { modo === 'I' ? 
                      <button type="submit" className="btnx btnx-warn">Registrar</button> 
                      : 
                      <button type="submit" className="btnx btnx-warn">Modificar</button>
                    }
                    {' '}<button onClick={cancelOperation} type="button" className="btnx btnx-warn">Cancelar</button>
                </div>
            </Col>
          </Row>
          </form>
        </Card>
      </Col>
    </Row>
    <Row className="mt-3">
    <Col lg={12}>
     <Card>
      <Row>
        <Col>
          <div className="row mt-3">
              <div className="col">
                  <h4>Guias Master</h4>
              </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <DataTableExtensions
            columns={tableMaster.colummnsWithFunc(selectionClient, removeMaster, config.tipo, closeMaster, utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones))}
            data={listado}
            export={false}
            print={false}
            filterPlaceholder="Buscar guia master"
          >
              <DataTable
                noHeader
                customStyles={tableMaster.customStyles}
                dense={true}
                pagination={true}
                paginationPerPage={50}
                noDataComponent={"Sin datos asociados"}
                style={{ 
                  minHeight: 400,
                }}
            />
          </DataTableExtensions>
        </Col>
       </Row>
      </Card>
     </Col>
    </Row>

    <Row className="mt-3">
    <Col lg={12}>
     <Card>
      <Row>
        <Col>
           <DataTable
            title="Master completadas"
            customStyles={tableMaster.customStyles}
            columns={tableMaster.colummnsComplete()}
            data={listacomplete}
            dense={true}
            pagination={true}
            paginationPerPage={50}
            noDataComponent={"Sin datos asociados"}
          />
        </Col>
       </Row>
      </Card>
     </Col>
    </Row>

    <ConfirmAlert
        show={confirm}
        message="Eliminar guia master seleccionada"
        onCancel={() => setConfirm(false)}
        onConfirm={() => removeAccept()}
    />
    <ConfirmAlert
      show={confirm2}
      message="Marcar esta guia master como completada"
      onCancel={() => setConfirm2(false)}
      onConfirm={() => closedmaster()}
    />
    </>
  )
}

export default Master;